module.exports = __webpack_public_path__ + "img/gold.f6747703.png";